export default {
  title: 'Otrzymuj automatyczne miesięczne ulotki',
  status: {
    enabled: 'Włączone',
    disabled: 'Wyłączone',
  },
  opt_out: {
    on_hint: 'Twój plan Foodamigos obejmuje 500 bezpłatnych ulotek miesięcznie. Wyłącz, aby przestać je otrzymywać.',
    off_hint: 'Automatyczne ulotki są wstrzymane. Włącz, aby wznowić od następnego miesiąca.',
    confirm_off: {
      title: 'Wyłączyć automatyczne ulotki?',
      body: 'Wyłączenie oznacza, że {{location}} nie będzie otrzymywać automatycznych ulotek od następnego miesiąca. Istniejące zamówienia pozostają bez zmian.',
      confirm: 'Wyłącz',
      cancel: 'Zostaw włączone',
    },
  },
  approved_design: {
    label: 'Zatwierdzony projekt ulotek miesięcznych',
    auto_option: 'Automatycznie (ostatnio zamówiona)',
    flyer_slot: 'Ulotka {{slot}}',
    custom: 'Własna',
    untitled: 'Bez nazwy',
    invalid_warning:
      'Zapisany projekt jest niedostępny. Do czasu wyboru nowego będzie używana ostatnio zamówiona ulotka.',
  },
  toasts: {
    failed_to_load: 'Nie udało się załadować ustawień automatycznych ulotek',
    failed_to_save: 'Nie udało się zapisać zmian',
    saved: 'Zmiany zapisane',
  },
};
